module.exports = __webpack_public_path__ + "slider6.7231ec1be088f3fe3058.jpg";


//////////////////
// WEBPACK FOOTER
// D:/Angular projects/memberreg/memberreg/src/assets/images/slider/slider6.jpg
// module id = ../../../../../src/assets/images/slider/slider6.jpg
// module chunks = styles